import React from "react";
import {connect} from "react-redux";
import {Form, Formik} from "formik";
import {traerPalabrasTabla} from "../../_actions";
import {buscadorConstants} from "../../_constants";
import Moment from "react-moment";
import MiTabla from "../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import authService from "../../_services/cart/authService";
import {UsuarioDP} from "./utils/adminUtils";
import {history, prepareDataSearch} from "../../_helpers";
import http from '../../_services/cart/http.service';
import alertService from "../../_services/cart/alert.service";
import {NavBarLateral} from "../includes";
import Select from "react-select";

const tableRefUsers = React.createRef();

const bagRef = React.createRef();
const _ = require("lodash");

class UsuariosList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        loading: false,
        nuevaBusqueda: false,
        show: false,
        producto: {},
        showUser: false,
        values:{},
        vendedorList:[{id:undefined, nombre:"Todos"},{id:false, nombre:"No"},{id:true, nombre:"Si"}]
    };

    componentDidMount() {

    }

    actualizar = () => {
        if (tableRefUsers.current) {
            tableRefUsers.current.onQueryChange();
        }
    };

    actualizarPageSize = (newPageSIze) => {

        if (tableRefUsers.current) {
            tableRefUsers.current.dataManager.changePageSize(newPageSIze)
        }

    };

    handleClose = () => {
        this.setState({
            showUser: false,
            producto: undefined,
            alert: undefined,
        });
    };

    buscarData = (query) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            http.post('/api/admin/users/buscar',
                prepareDataSearch(query, "createdDate", "DESC", this.state.values))
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    render() {
        if (!authService.hasAuthority("ADMIN")) {
            history.push('/');
        }

        const {loading, vendedorList} = this.state;

        const customSelect = {
            control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
                ...provided,
                background: 'transparent',
                borderColor: 'transparent',
                height: '58px',
                width: "100px"
            }),
        };

        const header = [
            {title: "ID", field: "id"},
            {
                title: "Username",
                field: "username",
                render: (row) => {
                    return (
                        authService.formatUserName(row)
                    );
                },
            },
            {title: "Email", field: "email"},
            {
                title: "Activo", field: "activo",
                render: (row) => (
                    <span>
            {row.activo ? 'Si' : 'No'}
          </span>
                )
            },
            {
                title: "Vendedor", field: "esVendedor",
                render: (row) => (
                    <span>
              {row.esVendedor ? 'Si' : 'No'}
            </span>
                )
            },
            // Fuera de la card en mobile: se ven en el detalle del usuario.
            {
                title: "Fecha Creado",
                field: "createdDate",
                mobile: false,
                render: (row) => (
                    <Moment date={row.createdDate} format="DD/MM/YYYY HH:mm"/>
                ),
            },
            {
                title: "",
                cellStyle: {textAlign: "center"},
                render: (row) => (
                    <div className="table-button">
                        <Link to={"/admin/userDetail?id=" + row.id}>
                            <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                             icon="fa-solid fa-eye"></FontAwesomeIcon>
                        </Link>
                    </div>
                ),
            },
        ];

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            pageSize: this.state.nuevo.limit,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };


        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Formik
                            enableReinitialize={true}
                            innerRef={bagRef}                            
                        >
                            {({values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <h2>Usuarios</h2>
                                        </div>
                                    </div>

                                    <div className="filter__container">
                                        <div className="filterby_container">
                                        <span>Filtrar por: </span>
                                        Es vendedor?
                                        <Select
                                                style={{width: '10%'}}
                                                className="sideBar-select"
                                                cacheOptions
                                                defaultOptions
                                                isClearable={false}
                                                value={
                                                   vendedorList
                                                        ?vendedorList.find(
                                                            (option) => option.id === this.state.esVendedor?.id
                                                        )
                                                        : ""
                                                }
                                                placeholder="Es Vendedor?"
                                                getOptionLabel={(option) => `${option.nombre}`}
                                                getOptionValue={(option) => option.id}
                                                options={this.state.vendedorList}
                                                onChange={(opt) => {
                                                    this.setState({values:{"esVendedor": opt}}, this.actualizar);
        
                                                }}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                styles={customSelect}
                                            />
                                       </div>
                                    </div>

                                    <div className="dashboard__content-main--tab">
                                        <MiTabla
                                            title=""
                                            tableRef={tableRefUsers}
                                            columns={header}
                                            options={options}
                                            style={{
                                                tableLayout: "auto",
                                                width: "100%",
                                                maxWidth: "100%",
                                                height: "auto",
                                                borderRadius: "1rem",
                                                border: "1px solid #d2d2d2",
                                                boxShadow: 'none',
                                                backgroundColor: 'inherit',
                                                color: 'inherit'
                                            }}
                                            data={(query) => this.buscarData(query, false)}
                                            detailPanel={(rowData) => {
                                                return <UsuarioDP rowData={rowData}/>;
                                            }}
                                            localization={traerPalabrasTabla("Ventas")}
                                        />
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        {this.state.alert}
                    </div>
                </div>
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {};

const connectedUsuariosList = connect(mapState, actionCreators)(UsuariosList);
export {connectedUsuariosList as UsuariosList};
